import { useMutation } from "urql";

import { HandoverLimitRequestToRrDocument } from "../../../graphql/generated.ts";

export const useHandoverLimitRequestToRR = () =>
  useMutation(HandoverLimitRequestToRrDocument);
